export interface RouteMeta {
  title: string;
  description: string;
  canonical?: string;
  ogImage?: string;
  noindex?: boolean;
  jsonLd?: object | object[];
  hreflang?: { lang: string; href: string }[];
}

const BASE_URL = 'https://cyxey.uk';

export const ROUTE_META: Record<string, RouteMeta> = {
  '/': {
    title: '今彩539工具箱｜539開獎號碼查詢、走勢圖、開獎單列印、對獎工具',
    description: '今彩539工具箱：免費查今彩539開獎號碼、近20／30／50／100期走勢圖、開獎單列印下載、對獎與獎金試算。資料以台灣彩券官方開獎結果為準，不報牌、不收費、免登入。',
    canonical: `${BASE_URL}/`,
    hreflang: [
      { lang: 'zh-TW', href: `${BASE_URL}/` },
      { lang: 'x-default', href: `${BASE_URL}/` },
    ],
    // CollectionPage + ItemList JSON-LD injected at component level via homepage-data.ts
  },
  '/faq': {
    title: '常見問題｜今彩539工具箱',
    description: '今彩539工具箱常見問題：開獎資料來源與更新時間、今彩539玩法與中獎規則、走勢圖與冷熱號怎麼看、理性購彩。',
    canonical: `${BASE_URL}/faq`,
    hreflang: [
      { lang: 'zh-TW', href: `${BASE_URL}/faq` },
      { lang: 'x-default', href: `${BASE_URL}/faq` },
    ],
    // FAQPage rich results only available for government/health sites since Aug 2023
    // Organization schema already in index.html
    jsonLd: undefined,
  },
  '/blog': {
    title: '539 統計與彩券知識文章｜今彩539工具箱',
    description: '今彩539開獎統計、冷熱號與遺漏值分析、走勢圖教學、賓果賓果與刮刮樂規則，以及運彩賠率知識文章。',
    canonical: `${BASE_URL}/blog`,
    hreflang: [
      { lang: 'zh-TW', href: `${BASE_URL}/blog` },
      { lang: 'x-default', href: `${BASE_URL}/blog` },
    ],
    jsonLd: {
      '@context': 'https://schema.org',
      '@type': 'CollectionPage',
      name: '539 統計與彩券知識文章',
      description: '今彩539開獎統計、走勢圖教學與彩券規則文章。',
      url: `${BASE_URL}/blog`,
      isPartOf: { '@id': `${BASE_URL}/#website` },
    },
  },
  '/about': {
    title: '關於我們｜今彩539工具箱',
    description: '今彩539工具箱是免費的今彩539開獎查詢與統計工具網站。資料來源、我們做什麼、不做什麼。',
    canonical: `${BASE_URL}/about`,
    hreflang: [
      { lang: 'zh-TW', href: `${BASE_URL}/about` },
      { lang: 'x-default', href: `${BASE_URL}/about` },
    ],
    jsonLd: {
      '@context': 'https://schema.org',
      '@type': 'AboutPage',
      name: '關於我們｜今彩539工具箱',
      url: `${BASE_URL}/about`,
      mainEntity: { '@id': `${BASE_URL}/#org` },
      isPartOf: { '@id': `${BASE_URL}/#website` },
    },
  },
  '/privacy': {
    title: '隱私政策｜今彩539工具箱',
    description: '今彩539工具箱隱私政策：說明我們如何收集、使用與保護您的個人資料，符合台灣個資法規範。',
    canonical: `${BASE_URL}/privacy`,
    hreflang: [
      { lang: 'zh-TW', href: `${BASE_URL}/privacy` },
      { lang: 'x-default', href: `${BASE_URL}/privacy` },
    ],
  },
  '/tools/539-calculator': {
    title: '539包牌計算器｜連碰立柱組數與成本一鍵試算',
    description: '539包牌計算器：選號後自動計算連碰、立柱（膽拖）所需組數與投注成本，支援二星、三星、四星玩法，幫你精準控制539包牌預算。',
    canonical: `${BASE_URL}/tools/539-calculator`,
    jsonLd: {
      '@context': 'https://schema.org',
      '@type': 'WebApplication',
      name: '539包牌計算器',
      description: '539包牌計算器：選號後自動計算連碰、立柱（膽拖）所需組數與投注成本，支援二星、三星、四星玩法，幫你精準控制539包牌預算。',
      url: `${BASE_URL}/tools/539-calculator`,
      applicationCategory: 'UtilitiesApplication',
      operatingSystem: 'Any',
      offers: { '@type': 'Offer', price: '0', priceCurrency: 'TWD' },
      inLanguage: 'zh-TW',
    },
  },
  '/tools/539-payout-calculator': {
    title: '539獎金計算器｜今彩539中獎獎金試算工具',
    description: '地下539賠率試算、中獎金額一秒算出。二星、三星、四星、全車獎金即時計算，比較官方台灣彩券 vs 地下539的賠率差異與期望值。',
    canonical: `${BASE_URL}/tools/539-payout-calculator`,
    jsonLd: {
      '@context': 'https://schema.org',
      '@type': 'WebApplication',
      name: '539獎金計算器',
      description: '地下539賠率試算、中獎金額一秒算出。二星、三星、四星、全車獎金即時計算，比較官方台灣彩券 vs 地下539的賠率差異與期望值。',
      url: `${BASE_URL}/tools/539-payout-calculator`,
      applicationCategory: 'UtilitiesApplication',
      operatingSystem: 'Any',
      offers: { '@type': 'Offer', price: '0', priceCurrency: 'TWD' },
      inLanguage: 'zh-TW',
    },
  },
  '/tools/539-number-analyzer': {
    title: '539選號分析器｜冷熱號統計、尾數分析、開獎趨勢圖',
    description: '免費539選號分析工具，提供近50期冷熱號排行、尾數頻率分析、奇偶比統計。用數據輔助選號，提升539投注策略。',
    canonical: `${BASE_URL}/tools/539-number-analyzer`,
    jsonLd: {
      '@context': 'https://schema.org',
      '@type': 'WebApplication',
      name: '539選號分析器',
      description: '免費539選號分析工具，提供近50期冷熱號排行、尾數頻率分析、奇偶比統計。用數據輔助選號，提升539投注策略。',
      url: `${BASE_URL}/tools/539-number-analyzer`,
      applicationCategory: 'UtilitiesApplication',
      operatingSystem: 'Any',
      offers: { '@type': 'Offer', price: '0', priceCurrency: 'TWD' },
      inLanguage: 'zh-TW',
    },
  },
  '/tools/odds-converter': {
    title: '運彩賠率換算器｜歐洲盤/美式盤/香港盤/馬來盤即時互轉',
    description: '免費運彩賠率換算器：歐洲盤、美式盤、香港盤、馬來盤一鍵互轉，含隱含勝率與莊家抽水率計算，幫助你快速比較不同盤口格式的賠率。',
    canonical: `${BASE_URL}/tools/odds-converter`,
    jsonLd: {
      '@context': 'https://schema.org',
      '@type': 'WebApplication',
      name: '運彩賠率換算器',
      description: '免費運彩賠率換算器：歐洲盤、美式盤、香港盤、馬來盤一鍵互轉，含隱含勝率與莊家抽水率計算，幫助你快速比較不同盤口格式的賠率。',
      url: `${BASE_URL}/tools/odds-converter`,
      applicationCategory: 'UtilitiesApplication',
      operatingSystem: 'Any',
      offers: { '@type': 'Offer', price: '0', priceCurrency: 'TWD' },
      inLanguage: 'zh-TW',
    },
  },
  '/tools/parlay-calculator': {
    title: '串關計算器｜運彩串關獎金試算、過關機率與期望值分析',
    description: '免費串關獎金計算器：輸入各關賠率，一鍵算出總賠率、潛在獎金、過關機率與期望值。支援過關組合計算，幫你制定最佳串關策略。',
    canonical: `${BASE_URL}/tools/parlay-calculator`,
    jsonLd: {
      '@context': 'https://schema.org',
      '@type': 'WebApplication',
      name: '串關獎金計算器',
      description: '免費串關獎金計算器：輸入各關賠率，一鍵算出總賠率、潛在獎金、過關機率與期望值。支援過關組合計算，幫你制定最佳串關策略。',
      url: `${BASE_URL}/tools/parlay-calculator`,
      applicationCategory: 'UtilitiesApplication',
      operatingSystem: 'Any',
      offers: { '@type': 'Offer', price: '0', priceCurrency: 'TWD' },
      inLanguage: 'zh-TW',
    },
  },
  '/tools/kelly-calculator': {
    title: '凱利公式計算器｜Kelly Criterion 最佳投注比例試算',
    description: '免費凱利公式計算器：輸入賠率與預估勝率，一鍵計算最佳投注比例。支援全凱利、半凱利、四分之一凱利，科學管理注碼、提升長期勝率。',
    canonical: `${BASE_URL}/tools/kelly-calculator`,
    jsonLd: {
      '@context': 'https://schema.org',
      '@type': 'WebApplication',
      name: '凱利公式計算器',
      description: '免費凱利公式計算器：輸入賠率與預估勝率，一鍵計算最佳投注比例。支援全凱利、半凱利、四分之一凱利，科學管理注碼、提升長期勝率。',
      url: `${BASE_URL}/tools/kelly-calculator`,
      applicationCategory: 'UtilitiesApplication',
      operatingSystem: 'Any',
      offers: { '@type': 'Offer', price: '0', priceCurrency: 'TWD' },
      inLanguage: 'zh-TW',
    },
  },
  '/author': {
    title: '編輯團隊｜今彩539工具箱',
    description: '今彩539工具箱編輯部：文章數據來源、寫作原則與更正方式。',
    canonical: `${BASE_URL}/author`,
    jsonLd: {
      '@context': 'https://schema.org',
      '@type': 'ProfilePage',
      mainEntity: {
        '@type': 'Organization',
        '@id': `${BASE_URL}/#org`,
        name: '今彩539工具箱',
      },
    },
  },
  '/editorial-policy': {
    title: '編輯政策與事實查核｜今彩539工具箱',
    description: '今彩539工具箱的資料來源、寫作原則、更新與更正流程。',
    canonical: `${BASE_URL}/editorial-policy`,
  },
};
